<template>
  <v-card class="card__container" tile>
    <v-toolbar flat dark color="primary toolbar__buttons">
      <v-btn
        color="info"
        text
        class="mr-5 btn"
        @click="previous()"
        :disabled="disabledPrevious"
      >
        <v-img
          src="../../../../assets/icons/anterior.png"
          style="cursor: pointer"
          alt="anterior"
          max-width="30"
          max-height="30"
          dark
        />{{ $tc("gestionEmpleados.previous") }}
      </v-btn>
      <v-btn color="info" text @click="next()" :disabled="disabledNext"
        >{{ $tc("gestionEmpleados.next") }}
        <v-img
          src="../../../../assets/icons/siguiente.png"
          style="cursor: pointer"
          alt="siguiente"
          max-width="30"
          max-height="30"
          dark
        />
      </v-btn>
      <v-btn @click="closeSteps" class="ml-2" text>{{
        $tc("newController.close")
      }}</v-btn>
    </v-toolbar>

    <div style="display: flex; justify-content: center">
      <v-card class="mt-2 mx-2 card__header">
        <ToolbarTitles :title="titleProcess" />
        <v-card-actions
          style="
            display: flex;
            flex-direction: row;
            justify-content: space-around;
          "
        >
          <v-text-field
            v-model="editItems.name"
            :disabled="disabledProcess"
            dense
            outlined
            label="Proceso"
            style="max-width: 320px"
            class="mr-2"
          />

          <v-select
            v-model="editItems.type"
            :disabled="disabledProcess || true"
           outlined
            dense
            label="Tipo"
            style="max-width: 320px"
            item-text="name"
            item-value="value"
            :items="typeProcess"
          />
        </v-card-actions>
        <div style="width: 600px">
          <v-text-field
            v-model="editItems.description"
            :disabled="disabledProcess"
            outlined
            dense
            label="Descripción"
          />
          <v-select
            v-model="editItems.concept"
            :disabled="disabledProcess"
            v-if="editItems.type == 'HSEX' || editItems.type == 'LICE'"
            dense
            outlined
            label="Concepto"
            item-text="name"
            item-value="id"
            :items="
              editItems.type === 'HSEX' ? getConceptsExtra : getConceptsLic
            "
          />
        </div>
        <div class="button__edit">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
             
                color="info"
                @click="editProcess"
                v-show="showEdit"
                v-bind="attrs"
                v-on="on"
                class="mr-4 mt-n15"
              >
                <v-icon small>fa-pen</v-icon>
              </v-btn>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="bt-acept mt-n15"
                @click="save"
                v-show="showSave"
              >
                {{ $tc("filter.save") }}</v-btn
              >
            </template>
            <span>Guardar</span>
          </v-tooltip>
          <v-btn
          
            color="info"
            @click="cancelEdit"
            v-show="showSave"
            class="ml-2 mt-n15 mr-4 bt-exit"
          >
            cancelar
          </v-btn>
        </div>
      </v-card>
    </div>

    <v-dialog v-model="showStep" max-width="500px" persistent>
      <v-card width="500px">
        <v-card-title class="flex-center">
          {{
            isEdit
              ? $tc("workflow.edit") + " " + $tc("workflow.steps")
              : $tc("workflow.add") + " " + $tc("workflow.steps")
          }}
        </v-card-title>

        <v-card-actions class="flex-center">
          <v-form ref="form" v-model="valid" style="width: 100%" >
            <AlertValidate :error="error" :alertValidate="alertValidate" />
            <v-text-field
              outlined
              dense
              label="Proceso"
              v-model="editItems.name"
              disabled
            />
            <v-text-field
              outlined
              dense
              label="Nombre"
              v-model="data.name"
              :rules="rules"
            />
            <v-select
              outlined
              label="Nivel"
              v-model="data.levels"
              dense
              :items="getLevels"
              :rules="rules"
              item-text="name"
              item-value="id"
            />
            <div style="display: flex; flex-direction: row; justify-content: center;">
              <v-switch
                v-for="item in itemSwitch"
                :key="item.label"
                color="accent"
                v-model="item.value"
                inset
                :label="item.label"
                class="mr-1 ml-1"
              />
            </div>
          </v-form>
        </v-card-actions>
        <div class="d-flex justify-space-between pb-2 px-3">
          <v-btn class="bt-exit mr-2 mb-2" @click="cancel"
            >{{ $tc("editRegistrations.cancel") }}
          </v-btn>
          <v-btn class="bt-acept" @click="validate">
            {{ $tc("editRegistrations.acept") }}</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showDelete" max-width="300px" persistent>
      <v-card>
        <v-card-title class="flex-center">
          {{ $tc("workflow.delete") + " " + $tc("workflow.step") }}
        </v-card-title>
        <v-card-actions class="flex-center">
          <div class="flex-center">
            <v-btn class="bt-exit mr-2 mb-2" @click="cancel"
              >{{ $tc("editRegistrations.cancel") }}
            </v-btn>
            <v-btn class="bt-acept" @click="deleteStep">
              {{ $tc("editRegistrations.acept") }}</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-col
      cols="12"
      sm="10"
      xs="12"
      md="9"
      :class="{ 'col-md-12': isChrome, 'col-md-10': isFirefox }"
    >
      <TableWithSearch
        :title="titleStep"
        :headers="allHeaders"
        :items="getProcessId"
        :openDialog="openDialog"
        @headersUpdated="updateHeaders"
      />
    </v-col>
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Alerts :alert="errorAlert" :color="colorError" :textAlert="textAlertOk" />
    <Alerts :alert="ok" :color="colorOk" :textAlert="textAlertOk" />
  </v-card>
</template>
<script>
import levels from "@/store/workflow/levels";
import process from "@/store/workflow/process";
import DataTableEmp from "../../../GestionEmpleados/commons/DataTableEmp.vue";
import AlertValidate from "../../../Complement/AlertValidate.vue";
import steps from "@/store/workflow/steps";
import Loader from "../../../Complement/Loader.vue";
import Alerts from "../../../GestionEmpleados/commons/Alerts.vue";
import ToolbarTitles from "../../../Complement/ToolbarTitles.vue";
import TableWithSearch from "../../../Complement/TableWithSearch.vue";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: {
    DataTableEmp,
    AlertValidate,
    Loader,
    Alerts,
    ToolbarTitles,
    TableWithSearch,
  },
  data() {
    return {
      disabledNext: false,
      titleTable: "WF_Procesos",
      titleStep: "Pasos",
      titleProcess: "Proceso",
      disabledPrevious: false,
      showStep: false,
      showEdit: true,
      showSave: false,
      disabledProcess: true,
      rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
      error: false,
      alertValidate: "",
      isLoading: false,
      colorError: "#FF8D58",
      colorOk: "#82A1D0",
      textAlertOk: "",
      errorAlert: false,
      valid: true,
      showDelete: false,
      ok: false,
      resetData: false,
      isEdit: false,
      oldEditItems: process.state.editItems,
      itemsDelete: {},
      itemSwitch: [
        { label: "Obligatorio", value: true, name: "mandatory" },
        { label: "Suficiente", value: true, name: "enough" },
        { label: "Enviar correo", value: true, name: "email" },
      ],
      data: {
        name: null,
        levels: null,
        mandatory: null,
        enough: null,
        email: null,
        id: null,
      },
    };
  },
  mounted() {
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (configTable.state.colums.length === 0 || configTable.state.colums.length !== this.headers.length ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });

    process.dispatch("getConceptLic");
    process.dispatch("getConcept");
    this.disabledButtons();
  },
  computed: {
    allHeaders() {
      return configTable.state.colums.Steps || [];
    },
    editItems() {
      return { ...process.state.editItems };
    },
    getConceptsExtra() {
      return process.state.concept.filter((e) => e.horTrab == "S" && e.id > 4);
    },
    getConceptsLic() {
      return process.state.conceptLic.filter((e) => e.id > 4);
    },
    typeProcess() {
      return process.state.typeProcess;
    },
    showSteps: {
      get() {
        return process.state.showSteps;
      },
      set(newvalue) {
        return newvalue;
      },
    },

    getProcessId() {
      return steps.state.processId.steps;
    },
    getLevels() {
      return levels.state.levels;
    },
    isFirefox() {
      return /Firefox/.test(navigator.userAgent);
    },
    isChrome() {
      return (
        /Chrome/.test(navigator.userAgent) &&
        /Google Inc/.test(navigator.vendor)
      );
    },
  },
  methods: {
      updateHeaders(headers) {
      const updatedColums = {
        ...configTable.state.colums,
        Steps: headers,
      };
     
      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (columnsToSave === undefined || this.allHeaders.length !== this.headers.length  || columnsToSave.length === 0) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    //cerrar dialog de pasos
    closeSteps() {
      process.commit("setShowSteps", false);
      this.showSteps = false;
      this.disabledButtons();
      this.disabledPrevious = false;
      this.disabledNext = false;
    },
    //proceso siguiente
    next() {
      let items = process.state.process;
      this.isLoading = true;
      let itemNext;
      for (let i = 0; i < items.length; i++) {
        if (items[i].id === this.editItems.id) {
          itemNext = items[i + 1];
        }
      }

      this.viewProcess(itemNext);
    },
    //proceso anterior
    previous() {
      let items = process.state.process;
      this.isLoading = true;
      let itemPrevious;
      for (let i = 0; i < items.length; i++) {
        if (items[i].id === this.editItems.id) {
          itemPrevious = items[i - 1];
        }
      }

      this.viewProcess(itemPrevious);
    },
    //vista del proceso seleccionado
    viewProcess(item) {
      const copia = { ...item };
      this.editItems = copia;
      steps.commit("setId", item.id);
      setTimeout(() => {
        this.isLoading = false;
      }, 1000);

      process.commit("setEditItems", copia);

      this.disabledNext = false;
      this.disabledPrevious = false;
      this.oldEditItems = { ...this.editItems };
      this.disabledButtons();

      steps.dispatch("getProcessId");
    },
    //disableo de botones anterior y siguiente
    disabledButtons() {
      let items = process.state.process;
      if (process.state.editItems.id == items[0].id) {
        this.disabledPrevious = true;
      }
      if (process.state.editItems.id == items[items.length - 1].id) {
        this.disabledNext = true;
      }
    },

    openDialog(type, item) {
      switch (type) {
        case "add":
          this.showStep = true;
          levels.dispatch("getLevels");
          break;
        case "edit":
          this.isEdit = true;
          this.showStep = true;
          this.data = {
            name: item.name,
            levels: item.levelId,
            id: item.id,
          };
          this.itemSwitch = [
            {
              label: "Obligatorio",
              value: item.mandatory !== "✔️" ? false : true,
              name: "mandatory",
            },
            {
              label: "Suficiente",
              value: item.enoght !== "✔️" ? false : true,
              name: "enoght",
            },
            { label: "Enviar correo ", value: true, name: "email" },
          ];
          break;
        case "delete":
          this.showDelete = true;
          this.itemsDelete = {
            step: item.id,
            process: this.editItems.id,
          };
          break;
        default:
          break;
      }
    },

    cancel() {
      if (this.showDelete) {
        this.showDelete = false;
      } else {
        this.showStep = false;
        this.isEdit = false;
        this.$refs.form.resetValidation();
        this.data = {
          name: null,
          levels: null,
          mandatory: null,
          enough: null,
          email: null,
        };

        (this.itemSwitch = [
          { label: "Obligatorio", value: true, name: "mandatory" },
          { label: "Suficiente", value: true, name: "enough" },
          { label: "Enviar correo", value: true, name: "email" },
        ]),
          (this.ok = false);
        this.errorAlert = false;
      }
    },
    //validacion del formulario add y edit
    validate() {
      let valid = this.$refs.form.validate();
      if (valid) {
        if (this.isEdit) {
          this.edit();
        } else {
          this.add();
        }
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },
    add() {
      this.isLoading = true;

      let payload = {
        process: this.editItems.id,
        name: this.data.name,
        levels: this.data.levels,
        mandatory: this.itemSwitch[0].value,
        enough: this.itemSwitch[1].value,
        email: this.itemSwitch[2].value,
      };
      steps.commit("setNew", payload);
      steps
        .dispatch("new")
        .then(() => {
          steps.dispatch("getProcessId");
          this.ok = true;
          this.isLoading = false;
          this.textAlertOk = this.$tc("workflow.addStep");
        })
        .catch((e) => {
          console.log(e);
          this.isLoading = false;
          this.errorAlert = true;
          this.textAlertOk = e.response.data.error.message;
        });
      this.cancel();
    },
    edit() {
      let payload = {
        name: this.data.name,
        levels: this.data.levels,
        mandatory: this.itemSwitch[0].value,
        enoght: this.itemSwitch[1].value,
        process: this.editItems.id,
        id: this.data.id,
      };
      steps.commit("setEdit", payload);
      steps
        .dispatch("edit")
        .then(() => {
          steps.dispatch("getProcessId");
          this.ok = true;
          this.isLoading = false;
          this.textAlertOk = this.$tc("workflow.editStep");
        })
        .catch((e) => {
          console.log(e);
          this.isLoading = false;
          this.errorAlert = true;
          this.textAlertOk = e.response.data.error.message;
        });
      this.cancel();
    },
    //elimino un paso
    deleteStep() {
      steps.commit("setDeleteItem", this.itemsDelete);
      steps
        .dispatch("delete")
        .then(() => {
          steps.dispatch("getProcessId");
          this.ok = true;
          this.isLoading = false;
          this.textAlertOk = this.$tc("workflow.deleteStep");
        })
        .catch((e) => {
          console.log(e);
          this.isLoading = false;
          this.errorAlert = true;
          this.textAlertOk = e.response.data.error.message;
        });
      this.cancel();
    },
    save() {
      this.isLoading = true;
      this.refreshItems();
      this.oldEditItems = { ...this.editItems };
      process.commit("setEdit", this.editItems);
      process
        .dispatch("edit")
        .then(() => {
          this.ok = true;
          this.isLoading = false;
          this.textAlertOk = this.$tc("workflow.editProcess");
          process.dispatch("getProcess");
        })
        .catch((e) => {
          console.log(e);
          this.isLoading = false;
          this.errorAlert = true;
          this.textAlertOk = e.response.data.error.message;
        });
      this.showEdit = true;
      this.showSave = false;
      this.disabledProcess = true;
    },
    editProcess() {
      this.disabledProcess = false;
      this.showSave = true;
      this.showEdit = false;
    },
    cancelEdit() {
      this.showEdit = true;
      this.showSave = false;
      this.disabledProcess = true;
      this.editItems = { ...this.oldEditItems };
    },
    //refresco los items
    refreshItems() {
      const updatedItem = process.state.editItems;
      let allProcess = process.state.process;
      let indice;

      allProcess.forEach((element, index) => {
        if (element.id === updatedItem.id) {
          indice = index;
        }
      });

      allProcess[indice] = updatedItem;
      process.commit("setProcess", allProcess);
    },
  },
};
</script>

<style scoped>
.toolbar__buttons {
  display: flex !important;
  flex-direction: row !important;
  justify-content: flex-end !important;
  padding-right: 0px;
  max-height: 64px !important;
}

.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}

.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}

.button__cancel {
  background-color: #a8a8a8 !important;
}

.button__edit {
  display: flex !important;
  justify-content: flex-end !important;
  width: 100%;
}



.flex-center {
  display: flex;
  justify-content: center;
}

.card__container {
  background-color: #eaf1f5 !important;
  overflow-y: hidden !important;
  width: 100%;
}

.card__header {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  border-radius: 25px;
}

@-moz-document url-prefix() {
  .toolbar__buttons {
    max-width: 1680px;
  }
}
</style>
